import styled, { css } from 'styled-components';
import { TooltipContent } from '../Tooltip/styles';
import { ButtonTypes } from '../../../types';
import { max } from '../../../theme/breakpoints';

interface IContentTextProps {
  withTooltip: boolean;
}

export const ContentText = styled.span<IContentTextProps>`
  display: block;
  overflow: hidden;
  position: relative;
  text-transform: uppercase;
  letter-spacing: 0.04em;

  span {
    padding: ${({ withTooltip }) => (withTooltip ? '0.5rem 0rem 0.5rem 2rem' : '0.5rem 2rem')};
  }
`;

export const GlobalTextContent = styled.span`
  font-size: 1rem;
  transition: all 0.12s ease-in-out;
  display: block;
  opacity: 1;
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  text-decoration: none;
`;

export const HiddenTextContainer = styled(GlobalTextContent)`
  opacity: 0;
  left: 0;
  right: 0;
  position: absolute;
  transform: translate3d(0, 56px, 0);
  display: block;
  transition: all 0.12s ease-in-out;
`;

export const ShowedTextContainer = styled(GlobalTextContent)``;

export const TooltipContainer = styled.span`
  padding: 0 2em 0 0;

  ${TooltipContent} {
    margin-top: 2rem;
  }
`;

interface IButtonWrapperProps {
  type: ButtonTypes;
  disabled: boolean;
}

export const ButtonWrapper = styled.a<IButtonWrapperProps>`
  color: ${({ theme }) => theme.colors.White};
  border-radius: ${({ theme }) => (theme.name === 'uplay' ? '4px' : '100px')};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 2px solid;
  vertical-align: top;
  cursor: pointer;
  text-decoration: none;
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  text-align: center;

  @media screen and ${max('tablet')} {
    width: 100%;
  }
  svg {
    margin-left: 1rem;
  }
  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.RipeLemon} !important;
  }
  ${TooltipContent} {
    margin-left: 0.5rem;
  }
  ${({ type, theme }) => {
    if (!type) {
      return {};
    }

    switch (type) {
      case 'buy':
        return css`
          background-color: ${theme.colors.Jade};
          border-color: ${theme.colors.Jade};
        `;
      case 'preorder':
        return css`
          background-color: ${theme.colors.CornflowerBlue};
          border-color: ${theme.colors.CornflowerBlue};
        `;
      case 'subscription':
        return css`
          background-color: ${theme.colors.Harlequin};
          border-color: ${theme.colors.Harlequin};
        `;
      case 'outlined':
        return css`
          color: ${theme.colors.text};
          background-color: transparent;
          border-color: ${theme.name === 'store' ? theme.colors.Black : theme.colors.White};

          svg path {
            fill: ${theme.name === 'store' ? theme.colors.Black : theme.colors.White};
          }
        `;
      case 'store-outlined':
        return css`
          color: ${theme.name === 'store' ? theme.colors.DeepCerulean : theme.colors.White};
          background-color: transparent;
          border-color: ${theme.name === 'store' ? theme.colors.DeepCerulean : theme.colors.White};
        `;
      default:
        return css`
          background-color: ${theme.colors.DeepCerulean};
          border-color: ${theme.colors.DeepCerulean};
        `;
    }
  }};

  ${({ disabled, theme }) =>
    disabled
      ? css`
          cursor: not-allowed;
          background-color: ${theme.colors.SilverChalice};
          border-color: ${theme.colors.SilverChalice};

          svg path {
            fill: ${theme.colors.White} !important;
          }
        `
      : css`
          cursor: pointer;

          &:hover {
            ${ShowedTextContainer} {
              transform: translate3d(0, -56px, 0);
            }
            ${HiddenTextContainer} {
              opacity: 1;
              transform: translate3d(0, 0, 0);
            }
          }
        `};
`;
